import { sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import { IListItem } from '../../list-page/interfaces/interfaces';

interface IProductTitleProps {
    product: IListItem,
    removeTitleLink?: boolean,
    isGridTitle?: boolean,
    listName?: string,
}

const ProductTitle = (props: IProductTitleProps) => {

    const product = props.product;

    return (
        <div
            className="font-bold mb-2 break-words"
            data-grid-title={ props.isGridTitle }
            onClick={ evt => {
                sendGAListPageEvent(product, props.listName);
             }
        }>
            { props.removeTitleLink && <span dangerouslySetInnerHTML={{ __html: product.documentName }} /> }
            {
                !props.removeTitleLink &&
                <a
                    href={ product.documentUrlPath }
                    title=""
                    className="no-underline text-gray-700 font-bold"
                    dangerouslySetInnerHTML={{ __html: product.documentName }} />
            }
        </div>
    )
};

export default ProductTitle;